export const ppmContract = `Please review the Private Placement Agreement at the below link and enter your first and last name in the form.`
export const opContract = `Please review the Operating Agreement at the below link and enter your first and last name in the form.`
export const subContract =  `Please review the Subscription Agreement below and enter your first and last name in the form.`

export const opContractII = `Please review the Operating Agreement at the below link. `
export const titleMain = `Terms and Conditions`

export const titleMainAlt = `Privacy Policy`
